import {rawRenderingLib, RenderingServices} from '@wallaby-ui/core';
import classNames from 'classnames';

import documentLinkRenderer from './document_link_renderer';
import styles from 'src/js/containers/encounter/components/EventAnnotation.less';
import {
  ENCOUNTER_DOCUMENT_ROUTE,
  ENCOUNTER_ROUTE,
} from 'src/js/containers/encounter/encounter_constants';
import {
  baseEventAnnotationParams,
  BaseEventAnnotationParams,
} from 'src/js/lib/raw_rendering/base_event_annotation_params';

/**
 * Returns raw DOM element version of EventAnnotation component.
 * @param params
 * @param services
 * @returns {Element}
 */

interface EventAnnotationRendererParams extends BaseEventAnnotationParams {}

export function eventAnnotationRenderer(
  params: EventAnnotationRendererParams,
  services: RenderingServices = {}
) {
  const {
    annotation,
    encounterId,
    documentId,
    colorStyle,
    label,
    searchParams,
    titleText,
  } = baseEventAnnotationParams(params, services);

  const divElem = document.createElement('div');
  divElem.className = styles.dlEventAnnotation;
  rawRenderingLib.RawRenderingService.setNodeStyle(
    divElem,
    annotation.getStyle()
  );

  let textElem;
  if (annotation.getDocumentId()) {
    textElem = document.createElement('span');
    textElem.className = classNames(
      styles.dlAnnotationLabel,
      styles.dlEventAnnotationPadding
    );
    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(textElem, label);
    rawRenderingLib.RawRenderingService.setNodeStyle(textElem, colorStyle);

    const documentLinkElem = documentLinkRenderer(
      {
        documentDetailRoute: `${ENCOUNTER_ROUTE}/${encounterId}${ENCOUNTER_DOCUMENT_ROUTE}/${documentId}`,
        titleText,
        searchParams,
        suppressPadding: true,
        children: textElem,
      },
      services
    );
    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(
      divElem,
      documentLinkElem
    );
  } else {
    textElem = document.createElement('span');
    textElem.className = styles.dlEventAnnotationPadding;
    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(textElem, label);
    rawRenderingLib.RawRenderingService.setNodeStyle(textElem, colorStyle);
    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(
      divElem,
      textElem
    );
  }

  return divElem;
}
